import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      venuesLists: [],
      formData: {
        venueInfo: ''
      },
      rules: {
        venueInfo: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formData.venueInfo = '';

                _this.getVenuseListFn();

                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getVenuseListFn: function getVenuseListFn() {
      var _this2 = this;

      this.$api.venuesList({
        is_team: 2,
        page_size: 1000
      }).then(function (res) {
        if (res.code == 200) {
          _this2.venuesLists = res.data.list;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      this.$emit('change', this.formData.venueInfo);
      this.dialogFormVisible = false;
    }
  }
};